import type { FC } from 'react';

import type { CMSHowToParticipateCard } from '@/api/cms/base';
import { ImageComponent } from '@/components/Image';

import {
  ScHowToParticipateSection,
  ScHowToParticipateSectionCard,
  ScHowToParticipateSectionTitle,
} from './styled';

interface HowToParticipateSectionProps {
  title: string;
  cards: CMSHowToParticipateCard[];
}

export const HowToParticipateSection: FC<HowToParticipateSectionProps> = ({
  title,
  cards,
}) => (
  <ScHowToParticipateSection>
    <ScHowToParticipateSectionTitle>{title}</ScHowToParticipateSectionTitle>
    <div className="cards">
      {cards.map(({ id, title, description, cardImage }) => (
        <ScHowToParticipateSectionCard key={id}>
          <ImageComponent
            alt="step card"
            className="image"
            height={128}
            src={cardImage?.url || ''}
            width={84}
          />
          <p className="title">{title}</p>
          {description && <p className="description">{description}</p>}
        </ScHowToParticipateSectionCard>
      ))}
    </div>
  </ScHowToParticipateSection>
);
